// auth-js writes a new PKCE code verifier cookie before it sends a link and
// deletes it when the send fails, for example on a 429. The link from the
// earlier email then has no verifier and stops working in this browser. Take
// a snapshot before the send and call the returned function on failure to put
// the earlier verifier back.

// @supabase/ssr splits long values into `<name>.0`, `<name>.1`, ...
const VERIFIER_COOKIE = /^sb-.+-code-verifier(\.\d+)?$/;
// The options @supabase/ssr writes its cookies with.
const ATTRIBUTES = `Path=/; SameSite=Lax; Max-Age=${400 * 24 * 60 * 60}`;

function verifierCookies(cookie: string): Map<string, string> {
  const found = new Map<string, string>();
  for (const pair of cookie.split("; ")) {
    const at = pair.indexOf("=");
    const name = at === -1 ? pair : pair.slice(0, at);
    if (VERIFIER_COOKIE.test(name)) found.set(name, pair.slice(at + 1));
  }
  return found;
}

export function snapshotCodeVerifier(doc: Document = document): () => void {
  const before = verifierCookies(doc.cookie);
  return () => {
    for (const name of verifierCookies(doc.cookie).keys()) {
      if (!before.has(name)) doc.cookie = `${name}=; Path=/; Max-Age=0`;
    }
    // Values stay as the browser stored them, already encoded.
    for (const [name, value] of before) {
      doc.cookie = `${name}=${value}; ${ATTRIBUTES}`;
    }
  };
}
